import React from 'react';
import styled from 'styled-components';
import WarningIcon from '../../assets/departureWifi/icon_warning.png';
import { ICON_CLOSE } from '@repo/assets';

type Props = {
  onClose: () => void;
  onOpenResolve?: () => void;
};

function IosWifiErrorModal({ onClose, onOpenResolve = () => {} }: Props) {
  return (
    <DimedWindow>
      <Modal>
        <CloseButton onClick={onClose}>
          <img src={ICON_CLOSE} alt='' width={16} />
        </CloseButton>
        <div>
          <TitleWrapper>
            <img src={WarningIcon} alt='' width={24} height={24} />
            <Title>와이파이 인증 오류</Title>
          </TitleWrapper>
          <Description>
            네트워크 오류 해결방법을
            <br />
            클릭하여 설정 확인 후 다시 시도해주세요.
            <br />
            <br />
            지속적인 네트워크 오류 발생시
            <br />
            항공권 업로드로 출국 인증해주세요.
          </Description>
        </div>
        <ButtonWrapper>
          <CancelButton href='/upload-ticket'>항공권 업로드</CancelButton>
          <Button
            onClick={() => {
              onOpenResolve();
              onClose();
            }}
          >
            해결방법 보기
          </Button>
        </ButtonWrapper>
      </Modal>
    </DimedWindow>
  );
}

const DimedWindow = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
`;

const Modal = styled.aside`
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 260px;
  margin: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #ed0828;
`;

const Button = styled.button`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: #246cf6;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
`;

const CancelButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: #e9f0fe;
  color: #246cf6;
  font-size: 16px;
  font-weight: 600;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  height: 48px;
`;

const Description = styled.p`
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #80848a;
  margin-bottom: 16px;
  line-height: 21px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
`;

export default IosWifiErrorModal;
